export default {
    methods: {
        calcAge: (birthday) => {
            if(!birthday) return 0;

            try{
                const birthDate = new Date(birthday);
                const by = birthDate.getFullYear().toString().padStart(4, '0');
                const bm = (birthDate.getMonth() + 1).toString().padStart(2, '0');
                const bd = birthDate.getDate().toString().padStart(2, '0');
    
                const today = new Date();
                const ty = today.getFullYear().toString().padStart(4, '0');
                const tm = (today.getMonth() + 1).toString().padStart(2, '0');
                const td = today.getDate().toString().padStart(2, '0');
    
                return Math.floor((Number(ty + tm + td) - Number(by + bm + bd)) / 10000);
            } catch {
                return 0;
            }
        }
    }
};
